import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UploadDp from "../../components/UploadDp";
// import { MdFileUpload } from "react-icons/md";
import { BsUpload } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
const apiBase = process.env.REACT_APP_API;


const EditProfile = ({ setIsLoading , setIsDpEdited}) => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    address: "",
    district: "",
    city: "",
  });

  const [isSavedBtnClicked, setIsSaveBtnClicked] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [message, setMessage] = useState("");

  useEffect(() => {
    setIsLoading(true);
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.post(
          `${apiBase}/profile`,
          {},
          {
            headers: {
              Authorization: `${token}`,
            },
          }
        );
        setProfile(response.data.profile?.[0]);
      } catch (error) {
        console.error("Error fetching profile data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaveBtnClicked(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${apiBase}/profile/edit`,
        profile,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      toast.success(response.data.message);
      setIsDpEdited(true);
      //   setMessage(response.data.message);
    } catch (error) {
      console.error("Error updating profile:", error);
      //   setMessage("Failed to update profile");
      toast.success(error);
    }finally{
      setIsSaveBtnClicked(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  const handleDeleteAccount = async () => {
    setIsDeleting(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(
        `${apiBase}/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success(response.data.message);
      localStorage.removeItem("token");
      navigate("/login");
    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error("Failed to delete account");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };

  return (
    <div className="pt-28 mb-10 flex flex-col items-center justify-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">
          Edit Profile
        </h2>
    <div className="max-w-screen-lg  p-10  flex-col items-center justify-center md:shadow-lg md:border md:rounded-lg">
      <div className="bg-white  rounded-2xl  w-full  ">

        {message && (
          <p className="text-center text-green-500 font-medium mb-4">
            {message}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-2">
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              First Name
            </label>
            <input
              type="text"
              name="first_name"
              value={profile.first_name}
              onChange={handleChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300 outline-none transition"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              Last Name
            </label>
            <input
              type="text"
              name="last_name"
              value={profile.last_name}
              onChange={handleChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300 outline-none transition"
            />
          </div>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              Phone
            </label>
            <input
              type="text"
              name="phone_number"
              value={profile.phone_number}
              disabled
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm bg-gray-100 text-gray-500 cursor-not-allowed outline-none transition"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              Email
            </label>
            <input
              type="text"
              name="email"
              value={profile.email}
              disabled
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm bg-gray-100 text-gray-500 cursor-not-allowed outline-none transition"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              Address
            </label>
            <input
              type="text"
              name="address"
              value={profile.address}
              onChange={handleChange}
              className="mt-1 p-3 block w-full border border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300 outline-none transition"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-2">

          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              District
            </label>
            <select
              name="district"
              id="district"
              value={profile.district}
              onChange={handleChange}
              className="block w-full p-2 border border-gray-300 rounded-md"
            >
              <option value="Colombo">Colombo</option>
              <option value="Gampaha">Gampaha</option>
              <option value="Kalutara">Kalutara</option>
              <option value="Kandy">Kandy</option>
              <option value="Matale">Matale</option>
              <option value="Nuwara Eliya">Nuwara Eliya</option>
              <option value="Galle">Galle</option>
              <option value="Matara">Matara</option>
              <option value="Hambantota">Hambantota</option>
              <option value="Jaffna">Jaffna</option>
              <option value="Kilinochchi">Kilinochchi</option>
              <option value="Mannar">Mannar</option>
              <option value="Vavuniya">Vavuniya</option>
              <option value="Mullaitivu">Mullaitivu</option>
              <option value="Batticaloa">Batticaloa</option>
              <option value="Ampara">Ampara</option>
              <option value="Trincomalee">Trincomalee</option>
              <option value="Kurunegala">Kurunegala</option>
              <option value="Puttalam">Puttalam</option>
              <option value="Anuradhapura">Anuradhapura</option>
              <option value="Polonnaruwa">Polonnaruwa</option>
              <option value="Badulla">Badulla</option>
              <option value="Moneragala">Moneragala</option>
              <option value="Ratnapura">Ratnapura</option>
              <option value="Kegalle">Kegalle</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-600 mb-1">
              City
            </label>
            <input
              type="text"
              name="city"
              value={profile.city}
              onChange={handleChange}
              className=" p-2 block w-full border border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-300 outline-none transition"
            />
          </div>
          </div>
          <button
            type="submit"
            className="w-full py-3 px-6 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition duration-200 shadow-md transform hover:scale-105"
            disabled = {isSavedBtnClicked}
          >
            {
              !isSavedBtnClicked ? "Update" : "processing..." 
            }
            
          </button>
        </form>
        <div className="mt-6">
          <button
            onClick={() => setShowDeleteModal(true)}
            className="hidden w-full py-3 px-6 bg-red-600 text-white font-bold rounded-lg hover:bg-red-700 transition duration-200 shadow-md transform hover:scale-105"
          >
            Delete Account
          </button>
        </div>
      </div>
        <hr className="h-0.5 mt-5 bg-gray-200 rounded-lg"/>
      <div className="flex flex-col items-center justify-center mt-10">
        <div className="w-full my-6 flex flex-col items-center bg-gray-100 p-4">
          <img src={profile.dp} alt="profile picture" className="max-w-lg rounded-lg" />
        </div>
      {/* <BsUpload className="size-28 text-myBlue mb-2 opacity-40"/> */}
        {/* <UploadDp /> */}
      </div>
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
            <h3 className="text-lg font-bold text-gray-800 mb-4">Delete Account</h3>
            <p className="text-gray-600 mb-6">
              Are you sure you want to delete your account? This action cannot be undone and all your data will be permanently removed.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 transition"
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteAccount}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete Account"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
};

export default EditProfile;
